<template>
    <b-card class="h-100" no-body :class="{ 'enabled': enabled }">
        <b-card-body @click="visit">
            <b-card-title>{{ tool.model }}</b-card-title>
            <b-card-sub-title>{{ name }}</b-card-sub-title>
            <b-card-img-lazy @click="visit" :src="tool.image + '?width=256'" :alt="tool.model"></b-card-img-lazy>
            <b-card-text v-if="!enabled" class="text-muted mt-1 mb-n2">
                {{ $t('text.not-available-in-your-region', { region: $t('region.' + $store.state.currentRegion) }) }}
            </b-card-text>
            <template v-if="showPrice">
                <div class="product-price text-muted mb-n1" v-if="adtractionProducts.length > 0">
                    <span>{{ adtractionProducts[0].programName }}</span>
                    <i18n-n :value="adtractionProducts[0].productPrice"
                            :format="{ style: 'currency', currency: adtractionProducts[0].currency, minimumFractionDigits: 0 }"
                            v-if="adtractionProducts.length > 0"></i18n-n>
                </div>
            </template>
        </b-card-body>
        <b-card-footer :class="{ 'owned': isOwned }" @click="toggleModelOwned">
            <div>
                <b-icon-check-square v-if="isOwned"></b-icon-check-square>
                <b-icon-square v-else></b-icon-square>
            </div>
            <div>
                <template v-if="isOwned">{{ $t('text.owned') }}</template>
                <template v-else>{{ $t('text.not-owned') }}</template>
            </div>
        </b-card-footer>
    </b-card>
</template>

<script>
import Adtraction from '@/util'

export default {
  name: 'ToolCard',
  props: {
    tool: { type: Object },
    enabled: { type: Boolean },
    showPrice: { type: Boolean }
  },
  data () {
    return {
      adtractionProducts: []
    }
  },
  methods: {
    toggleModelOwned () {
      this.$store.commit('toggleModelOwned', this.tool.model)
    },
    visit () {
      this.$router.push({name: 'product', params: {model: this.tool.model}})
    },
    async loadAdtractionProducts () {
      this.adtractionProducts = await Adtraction.getProducts(this.tool.model, true)
    }
  },
  watch: {
    async showPrice () {
      if (this.showPrice) {
        await this.loadAdtractionProducts()
      }
    }
  },
  async created () {
    if (this.showPrice) {
      await this.loadAdtractionProducts()
    }
  },
  computed: {
    isOwned () {
      return this.$store.state.ownedModels.includes(this.tool.model)
    },
    name () {
      const names = this.tool.name
      const region = this.$store.state.currentRegion
      if (region in names) {
        return names[region]
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .card.enabled {
        .card-body {
            display: flex;
            flex-direction: column;

            .card-img {
                margin-top: auto;
                margin-bottom: auto;
            }
        }

        .product-price {
            display: flex;
            justify-content: space-between;
        }
    }

  .card:not(.enabled) {
    color: #6c757d;

    .card-img {
      filter: grayscale(75%);
      opacity: 0.5;
    }

    .card-body {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

      .card-title {
          writing-mode: vertical-lr;
          text-orientation: mixed;
          margin: 0;
      }
        .card-subtitle {
            display: none;
        }

        .card-img {
            max-width: 75%;
            object-fit: contain;
            object-position: top;
        }

        .card-text {
            flex-basis: 100%;
            font-size: 75%;
            align-self: flex-end;
        }
    }
  }

  .card-footer {
    display: flex;
    cursor: pointer;
    user-select: none;

    > div:first-of-type {
      flex-grow: 0;
      font-size: 21px;
      margin: -0.25rem;
      margin-right: 0.5rem;
    }
    > div:last-of-type {
      flex-grow: 1;
    }

    &.owned {
      background-color: darkseagreen;
    }
    &:not(.owned) {
      background-color: indianred;
    }
  }
</style>